/* disc-fix-v2.js — v3: floating-cart styling only.

   REMOVED (they were breaking the sticky bar on /products/discovery-bundle):

   1. A requestAnimationFrame loop that toggled `.disc-sticky--visible` from the
      hero button's position, ~60x per second. On the live page the hero button's
      getBoundingClientRect().bottom stays at 0, so `past` was always false and the
      loop stripped the class every frame. The section could set it, this stripped
      it back, and the bar never appeared.

   2. An override of `.disc-sticky__btn` onclick that replaced the inline
      `discStickyATC()` with a scroll to #disc-bundle-selector. The DOM property
      beats the inline attribute, so the sticky Add to Cart button never added
      anything to the cart — it only scrolled.

   3. A duplicate /cart.js poll every 3s. sections/disc-sticky-bar.liquid already
      polls every 5s.

   sections/disc-sticky-bar.liquid is now the single owner of the sticky bar:
   visibility, price sync and the real add-to-cart. The .disc-sticky CSS below was
   also dropped — the section's own inline styles use #id selectors with
   !important and already won on specificity, so these rules were dead weight.
   Only the .disc-floating-cart styling is kept, because nothing else defines it. */
(function() {
  function init() {
    var style = document.createElement('style');
    style.textContent =
      '.disc-floating-cart{position:fixed;top:16px;right:16px;z-index:99998;background:#fff;border:2px solid #e5e7eb;border-radius:50%;width:52px;height:52px;display:flex;align-items:center;justify-content:center;font-size:1.3rem;cursor:pointer;box-shadow:0 4px 16px rgba(0,0,0,.12)}' +
      '.disc-floating-cart__count{position:absolute;top:-4px;right:-4px;background:#16a34a;color:#fff;font-size:.65rem;font-weight:800;width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center}';
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();